export default {
	searchParams: {
		userId: '',
		userName: '',
		userGbn: '',
		deptName: '',
		remark: ''
		// ,
		// msgLang: 'ko_KR',
		// parentScrId: null,
		// msgLoc: null,
		// msgKey: null,
		// msgText: null,
		// msgType: 'U' //메뉴명
	},
	userList: [],
	// groups: {
	// 	currentPage: 1,
	// 	pageUnit: 10,
	// 	totalSize: 0
	// },

	pagingInfo: {
		currentPage: 1,
		endPage: 1,
		pageUnit: 10,
		startPage: 1,
		totalSize: 1
	},

	// popup: {
	// 	groups: {
	// 		currentPage: 1,
	// 		pageUnit: 10,
	// 		totalSize: 0
	// 	}
	// },

	deptList: []
};
